import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, Welcome!`}</h1>
    <h3>{`This is a new site under development; an experimental, personal site for myself.`}</h3>
    <p>{`Please note this site has no affiliation with Bourne Identity, the books or such.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      